import { Dispatch, SetStateAction } from 'react'

export interface HexAndWaitProps {
  type: ELockType
  lock: () => void
  unlock: () => void
  locked: number
  locking: number
  setLocking: Dispatch<SetStateAction<number>>
  unlocking: number
  setUnlocking: Dispatch<SetStateAction<number>>
  discount: number
}

export interface LockingProps {
  type: ELockType
  lock: () => void
  locked: number
  locking: number
  setLocking: Dispatch<SetStateAction<number>>
  discount: number
}

export interface UnlockingProps {
  type: ELockType
  unlock: () => void
  locked: number
  unlocking: number
  setUnlocking: Dispatch<SetStateAction<number>>
  discount: number
}

export enum ELockType {
  HEX = 'HEX',
  WAIT = 'WAIT',
}

export enum EActionType {
  LOCK = 'LOCK',
  UNLOCK = 'UNLOCK',
}
